import { MAIN_ROUTES } from '@/router/components';
import sources from '@/router/sources';

export default {
  path: '/integrations',
  name: 'integrations',
  redirect: { name: 'sources' },
  meta: {
    requiresAuth: true,
    breadCrumb: 'app.navigation-drawer.integrations',
  },
  component: MAIN_ROUTES.INTEGRATIONS,
  children: [
    sources,
    {
      path: 'credentials',
      name: 'integrations.credentials.deprecated',
      redirect: { name: 'integrations.credentials' },
    },
  ],
};
